<template>
<div class="hello" style="overflow: hidden; height: 100vh; background-color: #202124;">
  <div>

    <!-- <form id="join-form">
      <div class="row join-info-group">
        <div class="col-sm">
          <p class="join-info-text">AppID</p>
          <input v-model="options.appid" id="appid" type="text" placeholder="enter appid" required>
          <p class="tips">If you don`t know what is your appid, checkout <a href="https://docs.agora.io/en/Agora%20Platform/terms?platform=All%20Platforms#a-nameappidaapp-id">this</a></p>
        </div>
        <div class="col-sm">
          <p class="join-info-text">Token(optional)</p>
          <input v-model="options.token" id="token" type="text" placeholder="enter token">
          <p class="tips">If you don`t know what is your token, checkout <a href="https://docs.agora.io/en/Agora%20Platform/terms?platform=All%20Platforms#a-namekeyadynamic-key">this</a></p>
        </div>
        <div class="col-sm">
          <p class="join-info-text">Channel</p>
          <input v-model="options.channel" id="channel" type="text" placeholder="enter channel name" required>
          <p class="tips">If you don`t know what is your channel, checkout <a href="https://docs.agora.io/en/Agora%20Platform/terms?platform=All%20Platforms#channel">this</a></p>
        </div>
        <div class="col-sm">
          <p class="join-info-text">UID</p>
          <input v-model="options.uid" id="uid" type="text" placeholder="enter channel name" required>
          <p class="tips">If you don`t know what is your channel, checkout <a href="https://docs.agora.io/en/Agora%20Platform/terms?platform=All%20Platforms#channel">this</a></p>
        </div>
      </div>

      <div class="button-group">
        <v-btn id="join" type="button" class="btn btn-primary btn-sm" @click="submit()">Join</v-btn>
        <v-btn id="leave" type="button" class="btn btn-primary btn-sm" @click="leave_btn()">Leave</v-btn>
        <v-btn id="mute-audio" type="button" class="btn btn-primary btn-sm" @click="muteAudio()">Mute Audio</v-btn>
        <v-btn id="mute-audio" type="button" class="btn btn-primary btn-sm" @click="unmuteAudio()">UnMute Audio</v-btn>
        |
        <v-btn id="mute-video" type="button" class="btn btn-primary btn-sm" @click="muteVideo()">Mute Video</v-btn>
        <v-btn id="mute-video" type="button" class="btn btn-primary btn-sm" @click="unmuteVideo()">UnMute Video</v-btn>
      </div>
    </form>

    <div class="row video-group">
      <div class="col">
        <p id="local-player-name" class="player-name"></p>
        <div id="local-player" class="player"></div>
      </div>
      <div class="w-100"></div>
      <div class="col">
        <div id="remote-playerlist"></div>
      </div>
    </div> -->

    <div class="row video-group" v-if="typeCall === 'video'">
        <v-layout row wrap justify-center align-center v-if="statusTime" style="height: 100vh; overflow: hidden;">
          <v-flex xs6 sm6 md6 lg6 xl6>
            <v-layout row wrap justify-center align-end style="height: 400px; border-radius: 10px; background-color: #000000; margin: 10px;">
              <div id="remote-playerlist" class="ma-1" v-if="!muteVideoUser"></div>
              <v-avatar
                :size="150"
                v-else
              >
              <img :src="infor_friend.picture" class="img-w-h" v-if="infor_friend.picture">
              <img src="/static/img/default_profile/bot-white.png" class="img-w-h" v-else>
              </v-avatar>
              <v-layout row wrap align-center style="width: 100%; margin-left: 10px; margin-bottom: 10px;">
                <h3 class="text-overflow mt-3 color-white">{{infor_friend.nickname}}</h3>
                <v-spacer></v-spacer>
                <v-icon dark color="white" style="margin-right: 10px; margin-top: 20px; font-size: 15px !important;" v-if="!muteStateFriend">fas fa-microphone</v-icon>
                <v-icon dark color="white" style="margin-right: 10px; margin-top: 20px; font-size: 15px !important;" v-else>fas fa-microphone-slash</v-icon>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-flex xs6 sm6 md6 lg6 xl6>
            <v-layout row wrap justify-center align-end style="height: 400px; border-radius: 10px; background-color: #000000; margin: 10px;">
              <div v-if="!muteStateVideo" id="local-player" class="player user-local-player ma-1"></div>
              <v-avatar
                :size="150"
                v-else
              >
              <img :src="picture_user" class="img-w-h" v-if="picture_user">
              <img src="/static/img/default_profile/bot-white.png" class="img-w-h" v-else>
              </v-avatar>
              <v-layout row wrap align-center style="width: 100%; margin-left: 10px; margin-bottom: 10px;">
                <h3 class="text-overflow mt-3 color-white">คุณ</h3>
                <v-spacer></v-spacer>
                <v-icon dark color="white" style="margin-right: 10px; margin-top: 20px; font-size: 15px !important;" v-if="!muteState">fas fa-microphone</v-icon>
                <v-icon dark color="white" style="margin-right: 10px; margin-top: 20px; font-size: 15px !important;" v-else>fas fa-microphone-slash</v-icon>
              </v-layout>
              <!-- <h3 class="text-overflow mt-3 color-white">คุณ</h3> -->
            </v-layout>

          </v-flex>
        </v-layout>
        <div class="col width-video-call-user" v-if="!statusTime" style="height: 80vh; overflow: hidden;">
          <v-layout column wrap justify-center align-center style="width: 100%;">
            <!-- <h2 class="text-overflow mt-3 color-white">{{infor_friend.nickname}}</h2> -->
            <!-- <h4 class="text-overflow mt-3 color-white" v-if="statusTime">
              {{secondsToHms(time_count)}}
            </h4> -->
            <v-avatar
              :size="150"
            >
            <img :src="infor_friend.picture" class="img-w-h" v-if="infor_friend.picture">
            <img src="/static/img/default_profile/bot-white.png" class="img-w-h" v-else>
            </v-avatar>
            <div class="loader">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </v-layout>
        </div>
      </div>
      <v-layout column wrap justify-center align-center v-if="typeCall === 'audio'" style="height: 85vh; overflow: hidden; background-color: black; margin: 20px; border-radius: 20px;">
        <v-avatar
          :size="150"
        >
        <img :src="infor_friend.picture" class="img-w-h" v-if="infor_friend.picture">
        <img src="/static/img/default_profile/bot-white.png" class="img-w-h" v-else>
        </v-avatar>

        <v-icon dark color="white" style="position: absolute; margin-top: 50px; font-size: 15px !important; top: 0px; right: 40px;" v-if="!muteStateFriend">fas fa-microphone</v-icon>
        <v-icon dark color="white" style="position: absolute; margin-top: 50px; font-size: 15px !important; top: 0px; right: 40px;" v-else>fas fa-microphone-slash</v-icon>

        <h2 class="text-overflow mt-5 color-white">{{infor_friend.nickname}}</h2>
        <h4 class="text-overflow mt-3 color-white" v-if="statusTime">
          <!-- {{secondsToHms(time_count)}} -->
        </h4>
        <div class="loader" v-else>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </v-layout>

      <v-layout row wrap justify-center align-center class="layout-bottom">
        <div class="agora-button">
          <v-btn v-if="!muteState" color="primary" dark plain fab small @click="muteAudio()" :disabled="!statusTime">
            <v-icon dark color="white">fas fa-microphone</v-icon>
          </v-btn>
          <v-btn v-else color="primary" plain fab small @click="unmuteAudio()">
            <v-icon dark color="white">fas fa-microphone-slash</v-icon>
          </v-btn>
          <v-btn color="green" @click="submit()" :disabled='disableJoin' fab dark small>
            <v-icon dark color="white">fas fa-phone</v-icon>
          </v-btn>
          <v-btn color="primary" plain fab dark @click="switchToVideo()" v-if="typeCall === 'audio'" small :disabled="!statusTime">
            <v-icon dark color="white">fas fa-video</v-icon>
          </v-btn>
          <div v-if="typeCall === 'video'">
            <v-btn v-if="!muteStateVideo" color="primary" dark plain fab @click="muteVideo()" small :disabled="!statusTime">
              <v-icon dark color="white">fas fa-video</v-icon>
            </v-btn>
            <v-btn v-else color="primary" plain fab @click="unmuteVideo()" small>
              <v-icon dark color="white">fas fa-video-slash</v-icon>
            </v-btn>
          </div>
          <v-btn color="red" @click='leave_btn()' plain :disabled='!disableJoin' fab dark small>
            <v-icon dark color="white">fas fa-phone-slash</v-icon>
          </v-btn>
        </div>
      </v-layout>

  </div>
  <EndCallDialog :EndCallDialog="EndCallDialog" :infor_friend="infor_friend" :time_count="time_count" @closeEndCallDialog="closeEndCallDialog"></EndCallDialog>
</div>
</template>
<script src="../../../AgoraRTC_N-4.6.3.js"></script>
<!-- <script src="../../../jquery-3.4.1.min.js"></script> -->
<script src="https://download.agora.io/sdk/release/AgoraRTC_N.js"></script>
<script>
import {AGORA_APP_ID} from "@/agora.config"
import AgoraRTC from 'agora-rtc-sdk-ng'
import { Decode } from '@/services'
import { sync } from 'vuex-pathify'
import EndCallDialog from '@/components/chat/agora_call/end_call_v2'

// create Agora client
var client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
var _ = require('lodash')
var localTracks = {
  videoTrack: null,
  audioTrack: null
}
var localTrackState = {
  videoTrackMuted: false,
  audioTrackMuted: false
}
let recorder;
let audio;

export default {
  components: {
    EndCallDialog
  },
  data () {
    return {
      options: {
        appid: null,
        channel: null,
        uid: null,
        token: null
      },
      remoteUsers: {},
      typeCall: '',
      disableJoin: false,
      time_count: 0,
      tokenuser: '',
      infor_friend: {},
      picture_user: '',
      EndCallDialog: false,
      muteState: false,
      muteStateFriend: false,
      muteStateVideo: false,
      muteVideoUser: false,
      statusTime: false,
      recordStatus: false
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...sync('*')
  },
  sockets: {
    connect () {
      console.log('socket connected')
      this.$socket.emit('join', {room: this.tokenuser, type: 'web'})
    },
    disconnect () {
      console.log('disconnected')
    },
    update_agora (data) {
      console.log(data)
      this.socket_update_agora = data
      if (data.status === 'end') {
        // end call
        this.disableJoin = false
        // this.leave_btn()
        this.cleartimer()
        if (this.typeCall !== 'video') {
          localTracks['audioTrack'].stop()
          localTracks['audioTrack'].close()
        } else {
          localTracks['videoTrack'].stop()
          localTracks['videoTrack'].close()
          localTracks['audioTrack'].stop()
          localTracks['audioTrack'].close()
        }

        // remove remote users and player views
        this.remoteUsers = {}
        if (document.getElementById('remote-playerlist') !== null) {
          document.getElementById('remote-playerlist').innerHTML = ''
          document.getElementById('local-player').innerHTML = ''
        }
        // leave the channel
        client.leave();
        var me = this
        setTimeout(function() {
          me.EndCallDialog = true
        }, 2000);
      }
    }
  },
  watch: {
    socket_update_agora (data) {
      console.log(data)
    },
  },
  created() {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = decoded['tokenuser']
    this.$socket.emit('join', {room: this.tokenuser, type: 'web'})

    this.infor_friend = JSON.parse(Decode.decode(this.$route.query.user_infor))
    this.options.token = Decode.decodeToken(this.$route.query.token)
    this.options.channel = Decode.decodeToken(this.$route.query.channel_name)
    this.options.appid = AGORA_APP_ID
    this.options.uid = this.infor_friend.one_id
    this.typeCall = this.$route.params.typecall
    this.picture_user = localStorage.getItem('profilepicture')
    console.log(this.infor_friend)
    console.log(this.options)
    // this.getRoom(this.tokenuser, this.$route.params.roomid)
    // this.getOneID(this.tokenuser)
    this.submit()
    // console.log(this.options)
    // console.log(this.infor_friend)
  },
  methods: {
    switchToVideo () {
      try {
      var me = this
        this.$swal({
          type: 'info',
          title: 'ต้องการเปลี่ยนเป็นวิดีโอคอลหรือไม่?',
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          showCloseButton: true,
          showCancelButton: true,
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            me.typeCall = 'video'
            client.unpublish(Object.values(localTracks));
            me.joinVideo()
            console.log(localTracks)
          } else {
            me.typeCall = 'audio'
          }
        })
      } catch (e) {
        console.log(e)
      }
      // me.typeCall = 'video'
      // await client.unpublish(Object.values(localTracks));
      // await me.joinVideo()
    },
    setAudio () {
      console.log(localTracks.audioTrack)
      if (!localTrackState.audioTrackMuted) {
        this.muteAudio();
      } else {
        this.unmuteAudio();
      }
    },
    async unmuteAudio () {
      console.log(localTracks.audioTrack)
      this.muteState = false
      if (!localTracks.audioTrack) return;
      await localTracks.audioTrack.setEnabled(true);
      localTrackState.audioTrackMuted = false;
    },
    async muteAudio () {
      console.log(localTracks.audioTrack)
      this.muteState = true
      if (!localTracks.audioTrack) return;
      await localTracks.audioTrack.setEnabled(false);
      localTrackState.audioTrackMuted = true;
    },
    async muteVideo() {
      console.log('muteVideo')
      console.log(localTracks.videoTrack)
      this.muteStateVideo = true
      if (!localTracks.videoTrack) return;
      await localTracks.videoTrack.setEnabled(false);
      localTrackState.videoTrackMuted = true;
    },
    async unmuteVideo() {
      console.log('un muteVideo')
      console.log(localTracks.videoTrack)
      this.muteStateVideo = false
      if (!localTracks.videoTrack) return;
      await localTracks.videoTrack.setEnabled(true);
      localTrackState.videoTrackMuted = false;
      localTracks.videoTrack.play("local-player");
    },
    async getOneID (tokenuser) {
      await this.axios.get(process.env.APIgo_api + `/v1/getOneID/${tokenuser}`).then((response) => {
        if (response.data.status === 'success') {
          this.options.uid = response.data.one_id
          // console.log(this.options)
          this.submit()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getRoom (tokenuser, tokenroom) {
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: tokenuser,
        tokenroom: tokenroom
      }).then((response) => {
        console.log(response.data)
        if (response.data.status === 'success') {
          this.infor_friend = response.data.data_room[0]
          console.log(this.infor_friend)
        }
      })
    },
    closeEndCallDialog (value) {
      this.EndCallDialog = value
      window.close()
    },
    async joinVideo () {
      try {
        console.log('join video')
        var me = this
        client.on("user-published", async (user, mediaType) => {
          await me.handleUserPublished(user, mediaType)
        });
        client.on("user-unpublished", async (user, mediaType) => {
          await me.handleUserUnpublished(user, mediaType)
        });
        client.on("user-info-updated", async (user, msg) => {
          await me.handleUserInfoUpdate(user, msg)
        })
        client.on("user-left", async (user, reason) => {
          await me.handleUserLeft(user, reason)
        });
        // client.on("network-quality", async (stats) => {
        //   await me.handleNetwork(stats)
        // })
        // add event listener to play remote tracks when remote user publishs.
        console.log(`mediaType: ${me.typeCall}`)
        localTracks = {
          videoTrack: null,
          audioTrack: null
        }
        localTrackState = {
          videoTrackMuted: false,
          audioTrackMuted: false
        }
        localTracks.audioTrack = await AgoraRTC.createMicrophoneAudioTrack()
        localTracks.videoTrack = await AgoraRTC.createCameraVideoTrack({
          encoderConfig: {
            width: 640,
            // Specify a value range and an ideal value
            height: { ideal: 480, min: 400, max: 500 },
            frameRate: 15,
            bitrateMin: 600, bitrateMax: 1000,
          }
        })
        localTracks.videoTrack.play("local-player");
        console.log(localTracks)
        // publish local tracks to channel
        await client.publish(Object.values(localTracks));
        var user = {
          uid: me.options.uid,
          videoTrack: localTracks.videoTrack,
          audioTrack: localTracks.audioTrack
        }
        console.log(user)
        // await client.subscribe(user, 'video')
        // me.unmuteVideo()
        console.log("publish video success");
      } catch (e) {
        console.log(e)
        console.log(localTracks)
      }
    },
    async join () {
      try {
        console.log('join')
        var me = this
        // add event listener to play remote tracks when remote user publishs.
        client.on("user-published", async (user, mediaType) => {
          await me.handleUserPublished(user, mediaType)
        });
        client.on("user-unpublished", async (user, mediaType) => {
          await me.handleUserUnpublished(user, mediaType)
        });
        client.on("user-info-updated", async (user, msg) => {
          await me.handleUserInfoUpdate(user, msg)
        })
        client.on("user-left", async (user, reason) => {
          await me.handleUserLeft(user, reason)
        });
        // client.on("network-quality", async (stats) => {
        //   await me.handleNetwork(stats)
        // })
        console.log(`mediaType: ${me.typeCall}`)
        if (me.typeCall === 'video') {
          localTracks = {
            videoTrack: null,
            audioTrack: null
          }
          localTrackState = {
            videoTrackMuted: false,
            audioTrackMuted: false
          }
        }
        if (me.typeCall === 'audio') {
          localTracks = {
            audioTrack: null
          }
          localTrackState = {
            audioTrackMuted: false
          }
        }
        // console.log(localTracks)
        // console.log(localTrackState)

        if (me.typeCall === 'video') {
          // join a channel and create local tracks, we can use Promise.all to run them concurrently
          [ me.options.uid, localTracks.audioTrack, localTracks.videoTrack ] = await Promise.all([
            // join the channel
            client.join(me.options.appid, me.options.channel, me.options.token || null, me.options.uid || null),
            // create local tracks, using microphone and camera
            AgoraRTC.createMicrophoneAudioTrack(),
            AgoraRTC.createCameraVideoTrack({
              encoderConfig: {
                width: 640,
                // Specify a value range and an ideal value
                height: { ideal: 480, min: 400, max: 500 },
                frameRate: 15,
                bitrateMin: 600, bitrateMax: 1000,
              }
            })
          ]);
          // play local video track
          localTracks.videoTrack.play("local-player");
        }
        if (me.typeCall === 'audio') {
          // join a channel and create local tracks, we can use Promise.all to run them concurrently
          [ me.options.uid, localTracks.audioTrack] = await Promise.all([
            // join the channel
            client.join(me.options.appid, me.options.channel, me.options.token || null, me.options.uid || null),
            // create local tracks, using microphone
            AgoraRTC.createMicrophoneAudioTrack()
          ]);
        }

        console.log(localTracks)
        // publish local tracks to channel
        await client.publish(Object.values(localTracks));
        console.log("publish success");
      } catch (e) {
        console.log(e)
      }
    },
    async leave () {
      // console.log(localTracks)
      try {
        for (var trackName in localTracks) {
          var track = localTracks[trackName];
          if(track) {
            track.stop();
            track.close();
            localTracks[trackName] = undefined;
          }
        }
        setTimeout(function() {
          window.close()
        }, 1000)
      } catch (e) {
        console.log(e)
      }

      // remove remote users and player views
      this.remoteUsers = {};
      if (document.getElementById('remote-playerlist') !== null) {
        document.getElementById('remote-playerlist').innerHTML = ''
        document.getElementById('local-player').innerHTML = ''
      }
      // document.getElementById('local-player-name').innerHTML = ''
      // leave the channel
      await client.leave();
      console.log("client leaves channel success");
      this.cleartimer()
      this.statusTime = false
      // this.updataState()
    },
    async subscribe (user, mediaType) {
      console.log('subscribe: ', mediaType)
      console.log(user)
      var me = this
      const uid = user.uid;
      // me.typeCall = mediaType
      console.log(`subscribe success: ${uid}`)
      // subscribe to a remote user
      await client.subscribe(user, mediaType);
      console.log(localTracks)
      if (mediaType === 'video') {
        me.typeCall = 'video'
        // ถ้า localTracks ยังไม่มี video แต่เพื่อนขอเปลี่ยนเป็น video
        if (localTracks.videoTrack === undefined) {
          me.$swal({
            type: 'warning',
            text: `${me.infor_friend.nickname} ต้องการสนทนาแบบวิดีโอคอล คุณต้องการเปิดกล้องใช่หรือไม่?`,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonColor: 'primary',
            cancelButtonColor: 'red'
          }).then((result) => {
            if (result.value) {
              console.log('document.getElementById ', document.getElementById('local-player') !== null);
              // ยังไม่เปิดกล้อง เปิดกล้องตัวเอง
              client.unpublish(Object.values(localTracks));
              me.joinVideo()
              // add subscribe video friend
              me.remoteUsers[uid] = user;
              console.log(me.remoteUsers[uid])
              // <p class="player-name">remoteUser(${uid})</p>
              const player = `
                <div id="player-wrapper-${uid}">
                  <div id="player-${uid}" class="player" style="width: 700px !important; height: 320px !important;"></div>
                </div>
              `
              document.getElementById("remote-playerlist").insertAdjacentHTML('beforeend', player)
              user.videoTrack.play(`player-${uid}`)
            }
          })
        } else {
          // ลบ element เก่า ออก
          const element = document.getElementById(`player-wrapper-${uid}`);
          console.log(element)
          if (element) {
            element.remove();
          }
          // add video friend ใหม่
          // <p class="player-name">remoteUser(${uid})</p>
          const player = `
            <div id="player-wrapper-${uid}">
              <div id="player-${uid}" class="player" style="width: 700px !important; height: 320px !important;"></div>
            </div>
          `
          document.getElementById("remote-playerlist").insertAdjacentHTML('beforeend', player)
          user.videoTrack.play(`player-${uid}`)
          // play local video track
          localTracks.videoTrack.play("local-player");
        }
      }
      if (mediaType === 'audio') {
        console.log('document friend: ', document.getElementById(`player-wrapper-${uid}`))
        console.log('document user: ', document.getElementById(`local-player`))
        if (localTracks.videoTrack !== undefined) {
          me.typeCall = 'video'
          if (document.getElementById(`player-wrapper-${uid}` !== null)) {
            user.videoTrack.play(`player-${uid}`)
            me.muteVideoUser = false
          } else {
            me.muteVideoUser = true
          }
          // play local video track
          localTracks.videoTrack.play("local-player");
        } else {
          me.typeCall = 'audio'
          user.audioTrack.play();
        }
      }
    },
    handleNetwork (stats) {
      console.log('handleNetwork: ', stats)
      console.log("downlinkNetworkQuality", stats.downlinkNetworkQuality);
      console.log("uplinkNetworkQuality", stats.uplinkNetworkQuality);
    },
    handleUserLeft (user, reason) {
      console.log(`handleUserLeft: `, user)
      console.log(`handleUserLeft Reason: `, reason)
      var me = this
      const id = user.uid;
      delete me.remoteUsers[id];
      // friend leave room
      if (reason === 'Quit') {
        if (user.uid !== me.options.uid) {
        setTimeout(function() {
          me.EndCallDialog = true
          me.statusTime = false
        }, 2000);
        }
      }
      // document.getElementById(`player-wrapper-${id}`).innerHTML = ''
    },
    handleUserPublished(user, mediaType) {
      console.log(`handleUserPublished: ${mediaType}`)
      console.log(`handleUserPublished: `, user)
      var me = this
      // friend join room start timer
      if (user.uid !== me.options.uid) {
        me.statusTime = true
        me.muteVideoUser = false
        me.settimer()
      }
      const id = user.uid;
      console.log(me.typeCall)
      me.remoteUsers[id] = user;
      me.subscribe(user, mediaType);
      console.log(me.remoteUsers[id])
    },
    handleUserJoined (user) {
      console.log('handleUserJoined:', user)
      var me = this
      const id = user.uid;
      me.remoteUsers[id] = user;
      console.log(me.remoteUsers[id])
    },
    handleUserInfoUpdate (user, msg) {
      console.log('handleUserInfoUpdate: ', user)
      console.log(`handleUserInfoUpdate: ${msg}`)
      var me = this
      if (user.uid !== me.options.uid) {
        if (msg === 'mute-video') {
          me.muteVideoUser = true
          const element = document.getElementById(`player-wrapper-${user.uid}`);
          console.log(element)
          if (element) {
            element.remove();
          }
        } else if (msg === 'unmute-video') {
          me.muteVideoUser = false
        } else if (msg === 'mute-audio') {
          me.muteStateFriend = true
        } else if (msg === 'unmute-audio') {
          me.muteStateFriend = false
        }
      }
    },
    handleUserUnpublished(user, mediaType) {
      console.log(`handleUserUnpublished: `, user)
      console.log(`handleUserUnpublished: ${mediaType}`)
      var me = this
      const id = user.uid;
      delete me.remoteUsers[id];
      if (mediaType === 'video') {
        const element = document.getElementById(`player-wrapper-${id}`);
        console.log(element)
        if (element) {
          element.remove();
        }
      }
    },
    async submit () {
      var me = this
      try {
        console.log(me.options)
        await me.join();
      } catch (error) {
        console.error(error);
      }
      this.disableJoin = true
      // this.settimer()
    },
    async leave_btn () {
      var me = this
      await me.leave()
    },
    secondsToHms (d) {
      d = Number(d)
      var hours   = Math.floor(d / 3600);
      var minutes = Math.floor((d - (hours * 3600)) / 60);
      var seconds = d - (hours * 3600) - (minutes * 60);
      var time = '';

      if (hours !== 0) {
        time = hours+':'
      }
      if (minutes !== 0 || time !== '') {
        minutes = (minutes < 10 && time !== '') ? '0' + minutes : String(minutes);
        time += minutes+':'
      }
      if (time === '') {
        time = seconds + 's'
      }
      else {
        time += (seconds < 10) ? '0' + seconds : String(seconds)
      }
      return time
    },
    cleartimer () {
      clearInterval(this.refreshIntervalId)
    },
    settimer () {
      this.refreshIntervalId = setInterval(() => this.getSecs(), 1000)
    },
    getSecs () {
      this.time_count = this.time_count + 1
    },
    updataState () {
      this.disableJoin = true
      console.log(this.infor_friend)
      this.axios.post(process.env.APIalpine + `/api/v1/update-agora`, {
        tokenroom: this.infor_friend.tokenroom,
        tokenmessage: this.infor_friend.tokenmessage,
        tokenuser: this.tokenuser,
        time: this.time_count.toString(),
        message: 'end'
      }).then((response) => {
        console.log(response.data)
        setTimeout(function() {
          window.close()
        }, 1000);
      }).catch(error => {
        console.log(error)
      })
    }
  },
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#watch-live-overlay img {
  height: auto;
  width: 100%;
  object-fit: contain;
  object-position: center;
}
  .user-local-player {
    /* position: absolute !important;
    right: 10px !important;
    top: 10px !important; */
    width: 700px !important;
    height: 320px !important;
  }
  .loader {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width : 100vw;
    /* height :100vh;
    background : #eee; */
    margin-top: 50px;
  }
  .loader > div {
    width: 10px;
    height: 10px;
    background: #8385aa;
    border-radius: 50%;
    margin : 3px;
    animation: loader 0.6s infinite alternate;
  }
  .loader > div:nth-child(2) {
    animation-delay: 0.2s;
  }
  .loader > div:nth-child(3) {
    animation-delay: 0.4s;
  }
  @keyframes loader {
    to {
      opacity: 0.1;
      transform: translate(0, -20px);
      background : pink;
    }
  }
  .width-video-call-friend {
    width: 100vw !important;
    justify-content: center !important;
    align-items: center !important;
    display: flex !important;
  }
  .width-video-call-user {
    width: 100vw !important;
    justify-content: end !important;
    align-items: end !important;
    display: flex !important;
    /* margin-left: 70vw !important; */
    position: absolute !important;
    /* bottom: 100px !important; */
  }
  .color-white {
    color: #ffffff !important;
  }
  .agora-box {
  }
  .agora-title {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    color: #2c3e50;
  }
  .agora-view {
    display: flex;
    flex-wrap: wrap;
  }
  .agora-video {
    width: 320px;
    height: 240px;
    margin: 20px;
  }
  .agora-input {
    margin: 20px;
    width: 320px;
  }
  .agora-text {
    margin: 5px;
    font-size: 16px;
    font-weight: bold;
  }
  .agora-button {
    display: flex;
    /* width: 160px; */
    justify-content: space-between;
    margin: 20px;
  }
  .agora-video {
    width: 320px;
    height: 240px;
  }
  .banner {
    padding: 0;
    background-color: #52575c;
    color: white;
  }

  .banner-text {
    padding: 8px 20px;
    margin: 0;
  }


  #join-form {
    margin-top: 10px;
  }

  .tips {
    font-size: 12px;
    margin-bottom: 2px;
    color: gray;
  }

  .join-info-text {
    margin-bottom: 2px;
  }

  input {
    width: 100%;
    margin-bottom: 2px;
  }

  .player {
    /* width: 640px !important;
    height: 480px !important; */
    width: 700px !important;
    height: 320px !important;
  }

  .player-name {
    margin: 8px 0;
  }

  #success-alert, #success-alert-with-token {
    display: none;
  }

  @media (max-width: 640px) {
    .player {
      width: 700px;
      height: 396px;
    }
  }
  .img-w-h {
    object-fit: cover;
    object-position: 50% 40%;
    height: 150px;
    width: 100%;
  }
  .text-overflow {
    max-width: 300px !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    overflow: hidden !important;
  }
  .layout-bottom {
    bottom: 0 !important;
    position: fixed !important;
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/agora_call/video_call_v3.vue